/// <reference path="../../Common/Base/SiteEntityGrid.ts" />

namespace Matrix.Data {
    
    @Serenity.Decorators.registerClass()
    export class PartyRolePartyGrid extends SiteEntityGrid<PartyRolePartyRow, any> {
        protected getColumnsKey() { return 'Data.PartyRoleParty'; }
        protected getDialogType() { return PartyRolePartyDialog; }
        protected getIdProperty() { return PartyRolePartyRow.idProperty; }
        protected getLocalTextPrefix() { return PartyRolePartyRow.localTextPrefix; }
        protected getService() { return PartyRolePartyService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}